<template>
  <div class="markList">
      <slot name="soltLeft"></slot>
     <!-- newFlag(小枫新标方式) 做兼容  -->
     <span v-for="(mark,idx) in markLists" :key="idx" style="font-size:0" v-show="mark.type !== 7 && mark.type !== 6">
        <!-- 跨店满减标 -->
        <slot name="soltCenter" v-if="showPopfullmins && mark.name=='popFullMins'"></slot>
        <img class="label-img" :src="mark.img" v-else-if="showAtmosphere && mark.type == 6 && mark.img">
        <img class="label-img" :src="mark.img" v-else-if="mark.type == 11 && mark.img">
        <i class="label-mark" v-else :class="{'label-mark-android':!isAndroid,'label-mark-ios':isAndroid,'label-redMark':((!mark.newFlag && (mark.type==1||mark.type==4||mark.type==2) )|| (mark.newFlag == 1 && mark.colorType == 1)),'label-purpleMark':(!mark.newFlag && mark.type==3) || (mark.newFlag == 1 && mark.colorType == 3)}" >{{mark.name}}</i>
     </span>
  </div>
</template>
<script type="text/ecmascript-6">
import YunJi from "common/js/YunJi.js";
import { ERR_CODE } from "common/js/Util.js";
export default {
  props: {
    markList: {
      type: [Array],
      default: function() {
        return [];
      }
    },
    appCont: {
      type: [Number, String],
      default: 0
    },
    showAtmosphere: {
      type: Boolean, //是否显示氛围标
      default: false
    },
    showPopfullmins: {
      type: Boolean, //是否显示跨店满减标 购物车用
      default: false
    }
  },
  data() {
    return {
      markedBuyAttachItemList: [],
      isAndroid: false
    };
  },
  computed: {
    markLists: function() {
      return this.markList.filter(function(mark) {
        return mark.name;
      });
    }
  },
  methods: {
    getMarketList(itemIds, productList) {
      //根据商品id查询该商品打什么标 2017-12-15新增
      this.$http
        .get(
          "//" +
            globalConfig.yunjimarketingapp +
            "/yunjimarketingapp/app/itemBusinessMark.json",
          {
            params: {
              appCont: this.appCont,
              itemIds: itemIds,
              strVersion: 1,
              businessMarkType: 1
            }
          }
        )
        .then(
          res => {
            let result = res.body;
            if (result.errorCode == ERR_CODE) {
              this.markedBuyAttachItemList = result.data;
              //动态在商品列表里面创建 字段 markFlag
              for (let i = 0; i < productList.length; i++) {
                for (let j = 0; j < this.markedBuyAttachItemList.length; j++) {
                  if (
                    productList[i].itemId ==
                    this.markedBuyAttachItemList[j].itemId
                  ) {
                    this.$set(
                      productList[i],
                      "markFlag",
                      this.markedBuyAttachItemList[j].mark
                    );
                    this.$set(
                      productList[i],
                      "markDescribe",
                      this.markedBuyAttachItemList[j].markText
                    );
                  }
                }
              }
              this.getMakArray(productList);
            }
          },
          res => {
            // toastShow("网络错误","warn");  // 接口调用失败
          }
        );
    },
    /**得到打标数组**/
    getMakArray(list) {
      for (let index = 0; index < list.length; index++) {
        var markArray = [];
        const element = list[index];
        for (let j = 0; j < YunJi.markOrderArray.length; j++) {
          const ele = YunJi.markOrderArray[j];
          switch (parseInt(ele)) {
            //活动标
            case 2:
              this.setActivityMark(element, markArray);
              break;
            //奖励表
            case 3:
              break;
            //跨境标
            case 4:
              this.crossMark(element, markArray);
              break;
            //新品标
            case 5:
              this.newItemMark(element, markArray);
              break;
          }
        }
        this.$set(element, "markArray", markArray);
      }
    },
    /**活动打标**/
    setActivityMark(element, markArray) {
      var markDes = "";
      //活动标
      if (element.shipmentsType != null && element.shipmentsType != 0) {
        markDes = "·预售";
      }
      if (element.markFlag != 0 && element.markDescribe) {
        markDes = "·" + element.markDescribe;
      }
      if (element.itemCategory == 3) {
        if (
          (element.markFlag == 6 ||
            element.markFlag == 4 ||
            element.markFlag == 5) &&
          element.markDescribe
        ) {
          markDes = "·" + element.markDescribe;
        } else {
          markDes = "";
        }
        markArray.push({ name: "定金预售" + markDes, type: 1 }); //定金预售
      } else if (element.itemCategory == 4) {
        if (element.shipmentsType != null && element.shipmentsType != 0) {
          markDes = "·预售";
        } else {
          markDes = "";
        }
        markArray.push({ name: "秒杀" + markDes, type: 1 });
      } else if (element.isClearGoods == 1) {
        markArray.push({ name: "清仓" + markDes, type: 1 });
      } else if (element.itemCategory == 1) {
        markArray.push({ name: "特卖" + markDes, type: 1 });
      } else if (element.itemCategory == 0 && element.markFlag != 0) {
        markArray.push({ name: element.markDescribe, type: 1 });
      }
    },
    /**跨境打标**/
    crossMark(element, markArray) {
      let ordinaryOrCross = "";
      switch (element.itemChannel) {
        case 3:
        case 8:
        case 12:
          ordinaryOrCross = "全球购";
          break;
        case 5:
        case 6:
        case 7:
        case 9:
        case 10:
        case 11:
        case 13:
          ordinaryOrCross = "全球购·包税";
          break;
      }
      if (ordinaryOrCross) {
        markArray.push({ name: ordinaryOrCross, type: 3 });
      }
    },
    /**新品打标**/
    newItemMark(element, markArray) {
      if (element.isNewItem && markArray.length < 3) {
        markArray.push({ name: "新品", type: 4 });
      }
    }
  },
  mounted() {
    this.isAndroid = YunJi.getPhoneType();
  }
};
</script>
<style>
.markList {
  height: 0.38rem;
  padding-top: .04rem;
  overflow: hidden;
  width: 100%;
  padding-left: 0.02rem;
}
.label-mark {
  display: block;
  float: left;
  padding: 0 0.04rem;
  margin-right: 0.08rem;
  border-radius: 3px;
  font-size: 0.2rem;
  line-height: 0.32rem;
  height: .32rem;
  margin-bottom: .08rem;
  box-sizing: border-box;
}
.label-mark-android {
  /* padding: 0.06rem 0.05rem 0.05rem; */
  position: relative;
  /* margin-top: 0.02rem; */
}

.label-mark-ios.label-redMark {
  border: 1px solid rgba(241, 13, 59, 0.35);
  color: #f10d3b;
}
.label-mark-ios.label-purpleMark {
  border: 1px solid rgba(113, 34, 188, 0.5);
  color: #7122bc;
}
.label-mark-android.label-redMark {
  color: #f10d3b;
}
.label-mark-android.label-redMark::before {
  content: "";
  opacity: 0.5;
  position: absolute;
  top: -50%;
  bottom: -50%;
  left: -50%;
  right: -50%;
  transform: scale(0.5);
  border: 1px solid #f10d3b;
  border-radius: 0.12rem;
}
.label-mark-android.label-purpleMark {
  color: #7122bc;
}
.label-mark-android.label-purpleMark::before {
  content: "";
  opacity: 0.5;
  position: absolute;
  top: -50%;
  bottom: -50%;
  left: -50%;
  right: -50%;
  transform: scale(0.5);
  border: 1px solid #7122bc;
  border-radius: 0.12rem;
}

.label-img {
  display: inline-block;
  height: 0.31rem;
  background-size: 100% 100%;
  margin-right: 0.08rem;
  float: left;
  margin-bottom: .08rem;
  box-sizing: border-box;
}
</style>

